import React, { useEffect, useState } from 'react';
import ProposalList from '../../../components/proposal'
const Nominee = (props) => {

    const [initialdata, setData] = useState([]);
    const [appointeeData, setAppointee] = useState([]);
    useEffect(() => {

        const { nomineeList } = props.proposalData;
        let apointee_data = [];
        let newdata = nomineeList && nomineeList.map((item, i) => {
            return Object.keys(item).map(res => {
                if (res === "appointeeDetails" && i === 0 && item[res].fullName) {
                    apointee_data.push({ name: 'FullName', value: item[res].fullName, show: true });
                    apointee_data.push({ name: 'Relationship', value: item[res].relationship, show: true })
                }
                return { name: res, value: item[res], show: true }
            })
        });
        setData(newdata);
        setAppointee(apointee_data)

    }, [props]);
    return (
        <>
            {initialdata && initialdata.map((item, i) => {

                return (<div className="main_container" key={i} >
                    < ProposalList initialdata={item} sectionLabel="Nominee Details" />
                </div>
                )
            })

            }
            {appointeeData && <div className="main_container">
                < ProposalList initialdata={appointeeData} sectionLabel="Apointee Details" />
            </div>
            }
        </>
    )
}

export default Nominee;
